interface ExpertiseStepProps {
  expertiseOptions: string[];
  selectedExpertise: string[];
  isLoading: boolean;
  onToggleExpertise: (expertise: string) => void;
  onSubmit: () => void;
  onSkip: () => void;
}

export const ExpertiseStep = ({
  expertiseOptions,
  selectedExpertise,
  isLoading,
  onToggleExpertise,
  onSubmit,
  onSkip,
}: ExpertiseStepProps) => {
  return (
    <div className="step-content step-4">
      <div className="step-header">
        <p className="step-subtitle">Let's set up your profile!</p>
        <h2 className="step-title">What are your fields of expertise?</h2>
      </div>

      {isLoading ? (
        <div style={{textAlign: 'center', padding: '2rem'}}>
          <p>Loading expertise options...</p>
        </div>
      ) : (
        <div className="expertise-options">
          {expertiseOptions.map((expertise) => (
            <label key={expertise} className="expertise-option">
              <input
                type="checkbox"
                checked={selectedExpertise.includes(expertise)}
                onChange={() => onToggleExpertise(expertise)}
              />
              <span className="expertise-label">{expertise}</span>
            </label>
          ))}
        </div>
      )}

      <button type="button" className="submit-button" onClick={onSubmit}>
        Continue
      </button>

      <button type="button" className="skip-button" onClick={onSkip}>
        Skip this step
      </button>
    </div>
  );
};
